import React, { memo } from 'react';
export interface Product {
  id: string;
  title: string;
  tagline: string;
  type: 'card' | 'memorabilia';
  image: string;
  badge: 'Graded' | 'Autographed' | 'Collectible' | null;
}
export const ProductCard = ({
  product
}: {
  product: Product;
}) => {
  const isCard = product.type === 'card';
  const ctaLabel = isCard ? 'Shop Cards' : 'Shop Memorabilia';
  const ctaHref = isCard ? '#shop' : '#memorabilia';
  return <div className="group flex flex-col bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border border-transparent hover:border-scarlet/30 hover:-translate-y-1" data-id="element-123">
      <div className="relative aspect-[4/5] bg-cream overflow-hidden p-4 flex items-center justify-center" data-id="element-124">
        {product.badge && <div className="absolute top-3 left-3 z-10 bg-ink text-white text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-125">
            {product.badge}
          </div>}
        <img src={product.image} alt={product.title} className="object-contain w-full h-full group-hover:scale-105 transition-transform duration-500" data-id="element-126" />
      </div>
      <div className="p-4 flex flex-col flex-grow" data-id="element-127">
        <p className="text-silver text-xs font-bold uppercase tracking-wider mb-1" data-id="element-128">
          {product.tagline}
        </p>
        <h3 className="font-heading text-lg leading-tight text-ink mb-4 flex-grow" data-id="element-129">
          {product.title}
        </h3>
        <a href={ctaHref} className="mt-auto inline-flex items-center justify-center bg-scarlet text-white px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wider hover:bg-scarlet/90 transition-colors focus:ring-2 focus:ring-scarlet focus:ring-offset-2 outline-none min-h-[44px]" data-id="element-130">
          {ctaLabel}
        </a>
      </div>
    </div>;
};